import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { CircularProgress } from "@material-ui/core";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch } from "react-redux";

export default function AddEmployeeToAssetDialog({
  open,
  setOpen,
  onSubmit,
  children,
}) {
  const [showLoader, setShowLoader] = useState(false);
  const handleSubmit = () => {
    setShowLoader(true);
    onSubmit();
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) {
      setShowLoader(false);
    }
  }, [open]);

  return (
    <div>
      <Dialog
        PaperProps={{
          sx: {
            width: "500px",
          },
        }}
        open={open}
        onClose={() => {
          // setOpen(true);
          //dispatch({ type: false });
        }}
      >
        <DialogTitle>ASSIGN</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            This Will Create A New Row
          </DialogContentText> */}
          {/* {showLoader ? (
            <>
              <br />
              <CircularProgress />
            </>
          ) : (
            <></>
          )}
          <br /> */}
          {children}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit} className="blue-button">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
